<template>
  <div
    class="diagram-line min-w-0"
    data-qa="diagram_line"
  >
    <div class="d-flex align-center gc-4 min-w-0">
      <div
        v-if="label"
        data-qa="diagram_line_label"
        class="diagram-line__label text-body-1 flex-shrink-0"
      >
        {{ label }}
      </div>
      <div class="diagram-line__track flex-grow-1 min-w-0">
        <div class="diagram-line__row d-flex align-center gc-2 w-100">
          <div
            class="diagram-line__progress flex-shrink-0"
            :style="{ width: progressBarWidth }"
          />
          <div
            class="diagram-line__value text-subtitle-1 flex-shrink-0"
            data-qa="diagram_line_percent"
          >
            {{ percent }}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue'

const props = defineProps<{
  label?: string
  percent: number
  volume: number
}>()
const { percent, volume } = toRefs(props)

const progressRatio = computed(() => percent.value / volume.value)

const progressBarWidth = computed(() => `calc((100% - 3rem) * ${progressRatio.value})`)
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.diagram-line {
  &__label {
    width: 84px;
  }

  &__progress {
    height: 20px;
    border-radius: $border-radius-md;
    background-color: $ui-kit-brand;
  }
}
</style>
